import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { CrossIcon } from '@ui/kit/icons';
import { IsomorphicPortal, CSSRefTransition } from '@utils/react';
import { CardOverlay } from './atom.card-overlay.js';
import { transitionDurationMs, container, backdrop, card, closeButton } from './atom.overlay-lightbox.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function OverlayLightbox(props) {
  return /*#__PURE__*/jsx(IsomorphicPortal, {
    children: /*#__PURE__*/jsx(CSSRefTransition, {
      in: props.active,
      classNames: container,
      timeout: transitionDurationMs,
      mountOnEnter: true,
      unmountOnExit: true,
      children: ref => /*#__PURE__*/jsxs("div", {
        ref: ref,
        className: cx(resets.rootCls, container),
        children: [/*#__PURE__*/jsx("div", {
          className: backdrop,
          onClick: props.onClose
        }), /*#__PURE__*/jsxs("div", {
          className: card,
          children: [/*#__PURE__*/jsx(CardOverlay, {
            ...props
          }), /*#__PURE__*/jsx("button", {
            onClick: props.onClose,
            "aria-label": "Luk kort",
            className: closeButton,
            children: /*#__PURE__*/jsx(CrossIcon, {
              height: "1.4rem"
            })
          })]
        })]
      })
    })
  });
}

export { OverlayLightbox };
//# sourceMappingURL=atom.overlay-lightbox.js.map
